import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { A } from 'wanderu-component-react-router-link';

import { renderChild } from '../Button/utils';

import styles from './LinkButton.scss';
// eslint-disable-next-line css-modules/no-unused-class
import buttonStyles from '../Button/Button.scss';

const propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string.isRequired,
    label: PropTypes.string,
    native: PropTypes.bool,
    onClick: PropTypes.func,
    target: PropTypes.string,
};

function LinkButton(props) {
    const {
        className = '',
        disabled = false,
        href = '',
        onClick,
        native = false,
        target,
        label,
    } = props;
    const cls = classnames(
        styles.linkButton,
        buttonStyles.button,
        buttonStyles.styledButton,
        className,
    );
    function handleClick(e) {
        if (disabled) {
            e.preventDefault();
            return;
        }

        if (onClick) {
            onClick();
        }
    }

    const opts = target === '_blank'
        ? { rel: 'noopener noreferrer' }
        : {};

    return (
        <A
            aria-label={label}
            className={cls}
            href={href}
            native={native}
            onClick={handleClick}
            target={target}
            underline="none"
            {...opts}
        >
            {renderChild(props)}
        </A>
    );
}

LinkButton.propTypes = propTypes;

export default LinkButton;
